import React, { Component } from 'react';
import connect from 'react-redux/es/connect/connect';
import { withRouter } from 'react-router-dom';
import { Box, TextField, Grid } from '@material-ui/core';
import BasicBreadcrumbs from '../../../components/organisms/basicBreadcrumbs/BasicBreadcrumbs';
import MainBody from '../../../components/templates/mainBody/MainBody';
import SearchBox from '../../../components/templates/searchBox/SearchBox';
import SearchSelectBox from '../../../components/atoms/searchSelectBox/SearchSelectBox';
import DeleteDataTable from '../../../components/templates/deleteDataTable/DeleteDataTable';
import FormTitle from '../../../components/atoms/formTitle/FormTitle';
import {
  actCallInitMailTemplateList, actCallApiMailTemplateList,
  actSetSearchCondition, actCallApiDeleteMailTemplate, actResetMailTemplateFlg,
} from '../../../redux/setting/mailTemplate/action';
import urls from '../../../constants/urls';

class MailTemplateList extends Component {
  constructor(props) {
    super(props);

    props.dispatch(actCallInitMailTemplateList());

    this.breadcrumbsText = [
      { name: 'メールテンプレート' },
    ];

    let isMain = false;

    let tempSearchCondition = {
      page: 0,
      records: 10,
      searchStoreId: null,
      searchFolder: null,
      searchKeyword: '',
    };
    let searchStore = null;
    if (props.common.user) {
      isMain = props.common.user.main;
      searchStore = props.common.user.store;
    }

    if (props.mailTemplates.searchCondition) {
      tempSearchCondition = props.mailTemplates.searchCondition;
    }
    if (searchStore) {
      tempSearchCondition.searchStoreId = searchStore;
      this.search(tempSearchCondition);
    }

    this.state = {
      isMain,
      selects: {
        stores: [],
        folders: [],
      },
      datas: [],
      searchCondition: tempSearchCondition,
    };
    this.headCells = [
      { id: 'title', numeric: false, label: 'タイトル' },
      { id: 'folder', numeric: false, label: 'フォルダ' },
    ];
  }

  componentDidMount() {
    document.title = 'メールテンプレート';
  }

  componentDidUpdate(prevProps) {
    if (prevProps.common.user !== this.props.common.user) {
      if (this.props.common.user) {
        this.setUser(this.props.common.user);
      }
    }
    if (prevProps.mailTemplates.datas !== this.props.mailTemplates.datas) {
      if (this.props.mailTemplates.datas) {
        this.setDatas(this.props.mailTemplates.datas);
      }
    }
    if (prevProps.mailTemplates.selects !== this.props.mailTemplates.selects) {
      if (this.props.mailTemplates.selects) {
        this.setSelect(this.props.mailTemplates.selects);
      }
    }
    if (prevProps.mailTemplates.isChangeSuccess !== this.props.mailTemplates.isChangeSuccess) {
      if (this.props.mailTemplates.isChangeSuccess) {
        this.setUpdateStopFlg();
      }
    }
  }

  setUser(user) {
    const { searchCondition } = this.state;
    const tempSearchCondition = {
      ...searchCondition,
      searchStoreId: user.store,
    };

    this.setState({ isMain: user.main, searchCondition: tempSearchCondition });
    this.search(tempSearchCondition);
  }

  setSelect(selects) {
    this.setState({ selects });
  }

  setDatas(datas) {
    this.setState({ datas });
  }

  onChange = (event) => {
    const { searchCondition } = this.state;
    const tempSearchCondition = {
      ...searchCondition,
      [event.target.name]: event.target.value,
    };
    this.setState({ searchCondition: tempSearchCondition });
  }

  onStoreChangeSearch = (values) => {
    const { searchCondition } = this.state;
    this.setState({ searchCondition: { ...searchCondition, searchStoreId: values } });

    this.props.dispatch(
      actCallApiMailTemplateList({
        searchStoreId:
        values && values.id,
      }),
    );
  }

  onSearch = () => {
    const {
      searchCondition,
    } = this.state;
    this.search(searchCondition);
  }

  search = (searchCondition) => {
    this.props.dispatch(
      actCallApiMailTemplateList({
        ...searchCondition,
        searchStoreId: searchCondition.searchStoreId && searchCondition.searchStoreId.id,
      }),
    );
  }

  handleChangePage = (_, newPage) => {
    const { searchCondition } = this.state;
    const tempSearchCondition = {
      ...searchCondition,
      page: newPage,
    };
    this.setState({ searchCondition: tempSearchCondition });

    this.search(tempSearchCondition);
  };

  handleChangeRowsPerPage = (event) => {
    const { searchCondition } = this.state;
    const rowsPerPage = parseInt(event.target.value, 10);
    const tempSearchCondition = {
      ...searchCondition,
      page: 0,
      records: rowsPerPage,
    };

    this.setState({ searchCondition: tempSearchCondition });

    this.search(tempSearchCondition);
  };

  onDetail = (_, row) => {
    const { searchCondition } = this.state;
    this.props.dispatch(actSetSearchCondition(searchCondition));
    this.props.history.push({
      pathname: urls.SETTING.MAIL_TEMPLATE_DETAIL,
      state: {
        id: row.id,
      },
    });
  }

  onAdd = () => {
    const { searchCondition } = this.state;
    this.props.dispatch(actSetSearchCondition(searchCondition));
    this.props.history.push({
      pathname: urls.SETTING.MAIL_TEMPLATE_DETAIL,
      state: {
        id: null,
      },
    });
  }

  onDelete = (deleteList) => {
    this.props.dispatch(actResetMailTemplateFlg());
    this.props.dispatch(
      actCallApiDeleteMailTemplate({ deleteList }),
    );
  }

  render() {
    const {
      selects,
      datas,
      isMain,
      searchCondition,
    } = this.state;

    return (
      <>
        <BasicBreadcrumbs breadcrumbs={this.breadcrumbsText} />
        <MainBody>

          <SearchBox onSearch={this.onSearch}>
            <Grid container spacing={1}>
              {isMain && (
                <Grid item md={3} xs={12}>
                  <FormTitle title="店舗" />
                  <SearchSelectBox options={selects.stores} value={searchCondition.searchStoreId} onChange={this.onChange} name="searchStoreId" disableClearable />
                </Grid>
              )}
              <Grid item md={3} xs={12}>
                <FormTitle title="フォルダ" />
                <SearchSelectBox
                  options={
                    searchCondition.searchStoreId
                      ? selects.folders.filter(
                        (folder) => folder.mstStoreId === searchCondition.searchStoreId.id,
                      )
                      : selects.folders
                  }
                  value={searchCondition.searchFolder}
                  onChange={this.onChange}
                  name="searchFolder"
                />

              </Grid>
            </Grid>
            <Box>
              <FormTitle title="キーワード" />
              <TextField variant="outlined" fullWidth value={searchCondition.searchKeyword} name="searchKeyword" onChange={this.onChange} />
            </Box>
          </SearchBox>

          <DeleteDataTable
            rows={datas.content ? datas.content : []}
            headCells={this.headCells}
            addButtonLabel="メールテンプレートの追加"
            deleteButtonLabel="メールテンプレートの削除"
            page={searchCondition.page}
            rowsPerPage={searchCondition.records}
            totalElements={datas.totalElements}
            handleChangePage={this.handleChangePage}
            handleChangeRowsPerPage={this.handleChangeRowsPerPage}
            onDelete={this.onDelete}
            onAdd={this.onAdd}
            deleteDialogTitle="メールテンプレートの削除"
            deleteDialogContent="選択したメールテンプレートを削除します。この操作は元に戻すことができません。"
            onDetail={this.onDetail}
            isMain={isMain}
          />
        </MainBody>
      </>
    );
  }
}
const mapStateToProps = (state) => ({ mailTemplates: state.mailTemplates, common: state.common });

export default withRouter(connect(mapStateToProps)(MailTemplateList));
